import { gql } from '@apollo/client'
import { useCleanFilterForRequest, useSearch, useSort } from '@btime/react-contexts'
import React from 'react'

import { checklistsClient } from '../../../../utils/apollo/api'
import { usePaginatedQuery } from '../../../../utils/apollo/_helpers/pagination'
import LazyAction from '../../../../components/helpers/LazyAction'
import StatePresenter from '../../../../components/helpers/StatePresenter'
import { cleanWhenEnabledFilterIsSet } from '../../../_helpers/filterByEnabled'

const Context = React.createContext()
const { Provider } = Context
export const useChecklistsState = () => React.useContext(Context) || {}
export const useChecklists = () => useChecklistsState()?.checklists || []

const QUERY = gql`
  query Checklists($page: Int, $search: String, $sort: ChecklistSort, $filter: ChecklistFilter) {
    checklists(page: $page, search: $search, sort: $sort, filter: $filter) {
      id
      name
      updatedAt
      usages
      type {
        id
        name
      }
      enabled
    }
  }
`

const ChecklistsLoader = ({ children, uncontrolledChildren }) => {
  const { field, type } = useSort()
  const search = useSearch()
  const filter = useCleanFilterForRequest()

  const { data, fetchMore, variables, ...state } = usePaginatedQuery(QUERY, {
    variables: {
      page: 1,
      search,
      sort: { field: field || 'NAME', type },
      filter: { ...cleanWhenEnabledFilterIsSet({ ...filter, includeDisabled: true }) }
    },
    client: checklistsClient
  })

  return (
    <Provider value={data}>
      <StatePresenter {...state} uncontrolledChildren={uncontrolledChildren}>
        {children}
        <LazyAction action={fetchMore} waiting={state.loading} />
      </StatePresenter>
    </Provider>
  )
}

export default ChecklistsLoader
